module.exports = __webpack_public_path__ + "images/vattenfall_small254d837e16a526d8cfbf2a2bf4270742.png";